import React, {
  useState,
  useEffect,
  useCallback,
} from "react";
import { Route, Switch } from "react-router-dom";
import { useAuth0, User } from "@auth0/auth0-react";
import { Box } from "@mui/material";
import LoginButton from "./components/login-button";

import TopNavigation from "./components/TopNavigation/TopNavigation";
import Loading from "./components/loading";
import PrivateRoute from "./components/private-route";
import HashboardHeatMapPage from "./minerstatusV2/Pages/HashboardHeatMap/index.js";
import HashboardHeatMapPageCS from "./techsupportMinerStatus/Pages/HashboardHeatMap/index.js";
import NotificationsManagementPage from "./Notifications/index.js";
import OrgPage from "./Org/org.js";
import TagManagementPage from "./TagMangement/TagManagement.js";

import Home from "./home/home";
import UserProfile from "./user/user";
import OrgProfile from "./user/org";
import DeviceList from "./device/device-list";
import DeviceGroup from "./device/device-group";
import Config from "./config/config";
import ZTPConfig from "./config/ztp-config";
import MinerConfig from "./config/miner-config-setup";
import StatsConfig from "./config/stats-config";
import ReviewConfig from "./config/review-config";
import DVFSConfig from "./config/dvfs-config";
import PriceConfig from "./config/price-config";
import DemandConfig from "./config/demand-config";
import ApiKey from "./user/apikey";
import JobPage from "./job/job";
import IndividualJobsPage from "./job/Pages/IndividualJobs.js";
import MinerStatus from "./minerstatus/device-list";
import TechsupportOnboard from "./techsupportOnboard/techsupportOnboard";
import GroupMgmt from "./minergroup/groupmgmt/device-group-mgmt.js";
import GroupOperations from "./minergroup/group-operations/group-operations.js";
import PoolsConfigurationPage from "./Pools/index.js";
import PriceConfigPage from "./PriceConfiguration/index.js";

import GroupInfo from "./minergroup/groupinfo/device-group-info.js";
import Dashboard from "./dashboard/dashboard";
import DashboardV2 from "./dashboard/dashboardV2";
import SitesAndGroupsManagementPage from "./SiteAndGroupManagement/SiteAndGroupManagement.js";
import FluxGPT from "./fluxgpt/fluxgpt";
import HomePage from "./home";
import MinerInventoryPage from "./minerstatusV2/index.js";
import WhiteListsPage from "./Pools/Pages/WhiteLists/WhiteLists";
import DemandResponsePage from "./DemandResponse/index.js";
import CSMinerInventoryPage from "./techsupportMinerStatus/index.js";

import UserPage from "./UserV2/index.js";

import Send from "./socket/send";
import DVFS from "./socket/dvfs";
import MockDVFS from "./socket/mockdvfs";
import Recieve from "./socket/recieve";
import EnergyTuning from "./socket/energyTuning";
import { withAuthenticationRequired } from "@auth0/auth0-react";

import "./App.css";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { ThemeProvider } from "./ThemeContext/ThemeContext.js";
import useAppContextProvider from "./AppContext/useAppContextProvider.js";
import Toast from "./components/Toast/Toast.js";
import { useHistory } from "react-router-dom/cjs/react-router-dom.js";
import { withRouter } from "react-router-dom/cjs/react-router-dom.js";
import TechSupportHomePage from "./TechSupportHome/index.js";
import MinerJobDetails from "./job/Pages/MinerJobDetails.js";
import MinerJobDetailsPageCS from "./job/Pages/MinerJobDetailsCS.js";
import CaseManagementPage from "./caseManagement/index.js";

const PrivateDeviceList = withAuthenticationRequired(
  DeviceList,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);
const PrivateDeviceGroup = withAuthenticationRequired(
  DeviceGroup,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);

const PrivateZTPConfig = withAuthenticationRequired(
  ZTPConfig,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);
const PrivateMinerConfig = withAuthenticationRequired(
  MinerConfig,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);
const PrivateStatsConfig = withAuthenticationRequired(
  StatsConfig,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);
const PrivateReviewConfig = withAuthenticationRequired(
  ReviewConfig,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);
const PrivateDVFSConfig = withAuthenticationRequired(
  DVFSConfig,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);

const PrivatePoolsPage = withAuthenticationRequired(
  PoolsConfigurationPage,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);

const PrivateDemandResponseConfigurationPage =
  withAuthenticationRequired(DemandResponsePage, {
    onRedirecting: () => <Loading />,
  });

const PrivateWhiteListsPage = withAuthenticationRequired(
  WhiteListsPage,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);

const PrivatePriceConfigPage = withAuthenticationRequired(
  PriceConfigPage,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);

const PrivatePriceConfig = withAuthenticationRequired(
  PriceConfig,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);
const PrivateDemandConfig = withAuthenticationRequired(
  DemandConfig,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);

const PrivateUserProfile = withAuthenticationRequired(
  UserProfile,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);
const PrivateOrgProfile = withAuthenticationRequired(
  OrgProfile,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);

const PrivateOrganizationPage = withAuthenticationRequired(
  OrgPage,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);

const PrivateApiKey = withAuthenticationRequired(ApiKey, {
  onRedirecting: () => {
    return <Loading />;
  },
});
const PrivateJob = withAuthenticationRequired(JobPage, {
  onRedirecting: () => {
    return <Loading />;
  },
});
const PrivateJobDetails = withAuthenticationRequired(IndividualJobsPage, {
  onRedirecting: () => {
    return <Loading />;
  },
});
const PrivateHashBoardsHeatMap = withAuthenticationRequired(
  HashboardHeatMapPage,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);
const PrivateHashBoardsHeatMapCS =
  withAuthenticationRequired(HashboardHeatMapPageCS, {
    onRedirecting: () => {
      return <Loading />;
    },
  });

const PrivateNotificationsPage = withAuthenticationRequired(
  NotificationsManagementPage,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);

const PrivateTagManagementPage = withAuthenticationRequired(
  TagManagementPage,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);

const PrivateMinerStatus = withAuthenticationRequired(
  MinerStatus,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);

const PrivateGroupMgmt = withAuthenticationRequired(
  GroupMgmt,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);
const PrivateGroupOperations = withAuthenticationRequired(
  GroupOperations,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);
const PrivateGroupInfo = withAuthenticationRequired(
  GroupInfo,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);

const PrivateDashboard = withAuthenticationRequired(
  Dashboard,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);

const PrivateHome = withAuthenticationRequired(HomePage, {
  onRedirecting: () => {
    return <Loading />;
  },
});
const PrivateDashboardV2 = withAuthenticationRequired(
  DashboardV2,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);
const PrivateFluxGPT = withAuthenticationRequired(FluxGPT, {
  onRedirecting: () => {
    return <Loading />;
  },
});
const PrivateTechsupportOnboard =
  withAuthenticationRequired(TechsupportOnboard, {
    onRedirecting: () => {
      return <Loading />;
    },
  });
const PrivateTechsupportMinerInventory =
  withAuthenticationRequired(CSMinerInventoryPage, {
    onRedirecting: () => {
      return <Loading />;
    },
  });

const PrivateMinerPage = withAuthenticationRequired(
  MinerInventoryPage,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);

const PrivateSupportHomePage = withAuthenticationRequired(
  TechSupportHomePage,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);

const PrivateSend = withAuthenticationRequired(Send, {
  onRedirecting: () => {
    return <Loading />;
  },
});
const PrivateDVFS = withAuthenticationRequired(DVFS, {
  onRedirecting: () => {
    return <Loading />;
  },
});
const PrivateMockDVFS = withAuthenticationRequired(
  MockDVFS,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);
const PrivateRecieve = withAuthenticationRequired(Recieve, {
  onRedirecting: () => {
    return <Loading />;
  },
});
const PrivateEnergyTuning = withAuthenticationRequired(
  EnergyTuning,
  {
    onRedirecting: () => {
      return <Loading />;
    },
  }
);

const PrivateUserPage = withAuthenticationRequired(
  UserPage,
  {
    onRedirecting: () => <Loading />,
  }
);
const PrivateMinerJobDetailsPage =
  withAuthenticationRequired( MinerJobDetails,{
    onRedirecting: () => {
      return <Loading />;
    },
  });
const PrivateMinerJobDetailsPageCS =
  withAuthenticationRequired( MinerJobDetailsPageCS,{
    onRedirecting: () => {
      return <Loading />;
    },
  });

const PrivateGroupsAndSitesManagement =
  withAuthenticationRequired(SitesAndGroupsManagementPage, {
    onRedirecting: () => <Loading />,
  });

const PrivateCaseManagementPage =
  withAuthenticationRequired(CaseManagementPage, {
    onRedirecting: () => <Loading />,
  });

const App = ({ location }) => {
  const { isLoading } = useAuth0();
  const history = useHistory();

  const routeToPageTitleMap = {
    "/": "Home",
    "/pools": "Pools Management",
    "/pools/whitelist": "Whitelist",
    "/priceConfig": "Price Configuration Management",
    "/user": "User Management",
    "/demandResponse":
      "Demand Response Configuration Management",
    "/organization": "Organization Management",
    "/jobresults": "Job Results",
    "/jobDetails": "Job Details",
    "/minerstatus": "Miner Inventory",
    "/hashboardheatmap": "Hashboard Heatmap",
    "/hashboardheatmapCS": "Hashboard Heatmap CS",
    "/tagmanagement": "Tag Management",
    "/notifications": "Notifications Management",
    "/techsupportonboard": "Tech Support Onboarding",
    "/techsupportminerstatus": "Tech Support Miner Status",
    "/sitegroupmanagement": "Site and Group Management",
    "/minerjobs": "Miner Job Details",
    "/minerjobsCS": "Tech Support Miner Job Details",
    "/caseManagement": "Case Management",
  };

  useEffect(() => {
    // Set the page title based on the current route
    const currentPath = window.location.pathname;
    const pageTitle =
      routeToPageTitleMap[currentPath] || "Home";
    document.title = `${pageTitle}`;
  }, [location.pathname]);

  const {
    getAccessTokenSilently,
    isAuthenticated,
    logout,
  } = useAuth0();
  const { setAuthToken } = useAppContextProvider();

  const retrieveAccessToken = async () => {
    if (!isAuthenticated) return null;
    try {
      const result = await getAccessTokenSilently();
      if (result !== "") {
        setAuthToken(result);
      }
    } catch (error) {
      console.error(
        " Error retrieving access token",
        error
      );
    }
  };

  // useeffect to set token
  useEffect(() => {
    // console.log("isAuthenticated", isAuthenticated, User);
    retrieveAccessToken();
  }, [isAuthenticated]);

  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    // Parse URL for Auth0 error parameters
    const params = new URLSearchParams(
      window.location.search
    );
    const error = params.get("error");
    const errorDescription = params.get(
      "error_description"
    );
    console.log(error, errorDescription);
    if (error) {
      // If an error exists, display it and remove the query params
      setErrorMessage(
        errorDescription || "An unknown error occurred."
      );

      alert(`${error} ${errorDescription}`);
      // Clean the URL to prevent reload loops
      logout({ returnTo: window.location.origin });
    }
  }, []);

  if (isLoading) {
    return <Loading />;
  }
  return (
    <MuiThemeProvider theme={theme}>
      <ThemeProvider>
        <Box id="app">
        <TopNavigation />
        <Box
          sx={{
            width: "auto",
            height: "auto",
          }}
        >
          <Toast />
          <Switch>
            <Route path="/" exact component={PrivateHome} />
            <Route path="/home" component={PrivateHome} />
            <Route
              exact
              path="/pools"
              component={PrivatePoolsPage}
            />
            <Route
              path="/pools/whitelist"
              component={PrivateWhiteListsPage}
            />
            <Route
              exact
              path="/priceConfig"
              component={PrivatePriceConfigPage}
            />
            <Route
              path="/user"
              component={PrivateUserPage}
            />
            <Route
              path="/demandResponse"
              component={
                PrivateDemandResponseConfigurationPage
              }
            />
            <Route
              path="/organization"
              component={PrivateOrganizationPage}
            />
            <Route
              exact
              path="/jobresults"
              component={PrivateJob}
            />
            <Route
              path="/jobDetails"
              component={PrivateJobDetails}
            />
            <Route
              path="/minerstatus"
              component={PrivateMinerPage}
            />
            <Route
              path="/hashboardheatmap"
              component={PrivateHashBoardsHeatMap}
            />
            <Route
              path="/tagmanagement"
              component={PrivateTagManagementPage}
            />
            <Route
              path="/notifications"
              component={PrivateNotificationsPage}
            />
            <Route
              path="/techsupportonboard"
              component={PrivateTechsupportOnboard}
            />
            <Route
              path="/techsupportminerstatus"
              component={PrivateTechsupportMinerInventory}
            />
            <Route
              path="/hashboardheatmapCS"
              component={PrivateHashBoardsHeatMapCS}
            />
            <Route
              path="/sitegroupmanagement"
              component={PrivateGroupsAndSitesManagement}
            />
            <Route
              path="/techSupportHome"
              component={PrivateSupportHomePage}
            />
            <Route
              path="/minerjobs"
              component={PrivateMinerJobDetailsPage}
            />
            <Route
              path="/minerjobsCS"
              component={PrivateMinerJobDetailsPageCS}
            />
            <Route
              path="/caseManagement"
              component={PrivateCaseManagementPage}
            />
          </Switch>
        </Box>
      </Box>
      </ThemeProvider>
    </MuiThemeProvider>
  );
};

export default withRouter(App);
